import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import {
  getInvestmentMethodsPaginated,
  IInvestmentMethodPaginatedResponse,
} from "api";
import { Nullable } from "config";
import { RootState } from "store/store";

import { IInvestmentMethodModalData } from "./types";
import { InvestmentMethodModalMode } from "./enums";

const initialState = {
  investmentMethodData: null as Nullable<
    IInvestmentMethodPaginatedResponse["edges"]
  >,
  totalCount: 1,
  loading: false,
  modalData: {
    open: false,
    mode: InvestmentMethodModalMode.VIEW,
  } as IInvestmentMethodModalData,
};

const actionTypeName = "investment-method-type";

export const fetchInvestmentMethods = createAsyncThunk(
  `${actionTypeName}/fetchInvestmentMethods`,
  async (_, { getState }) => {
    const filters = (getState() as RootState).FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }

    const response = await getInvestmentMethodsPaginated(filters);
    return response;
  }
);

const investmentMethodSlice = createSlice({
  name: actionTypeName,
  initialState,
  reducers: {
    setInvestmentMethodModalData: (
      state,
      action: PayloadAction<IInvestmentMethodModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeInvestmentMethodModal: (state) => {
      state.modalData = initialState.modalData;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchInvestmentMethods.fulfilled, (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          loading: false,
        };
      }
      return {
        ...state,
        investmentMethodData: action.payload?.edges,
        totalCount: action.payload?.totalCount,
        loading: false,
      };
    });
    builder.addCase(fetchInvestmentMethods.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const { setInvestmentMethodModalData, closeInvestmentMethodModal } =
  investmentMethodSlice.actions;

export default investmentMethodSlice.reducer;
